import { useState } from 'react'

export type UseAdjustmentsStateResult = {
  retirementAge: number | null
  setRetirementAge: (next: number | null) => void
  incomeRatio: number
  setIncomeRatio: (next: number) => void
  expenseRatio: number
  setExpenseRatio: (next: number) => void
}

export type UseAdjustmentsState = () => UseAdjustmentsStateResult

export const useAdjustmentsState: UseAdjustmentsState = () => {
  const [retirementAge, setRetirementAge] = useState<number | null>(null)
  const [incomeRatio, setIncomeRatio] = useState(0)
  const [expenseRatio, setExpenseRatio] = useState(0)

  return {
    retirementAge,
    setRetirementAge,
    incomeRatio,
    setIncomeRatio,
    expenseRatio,
    setExpenseRatio,
  }
}
